import React, { useCallback, useEffect, useState } from 'react';
import management from '../../Assets/managementBg.jpg';
import './management.css';
import ManagementItem from './ManagementItem';
import { message } from 'antd';
import AnimatedSection from '../AnimatedSection';

const Management = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [data, setdata] = useState([]);

  const fetchManager = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}/api/manager`);

      if (response.ok) {
        const data1 = await response.json();
        setdata(data1);
      } else {
        message.error("Server Hatası : Kullanıcılar Getirilemedi");
      }
    } catch (error) {
      console.log(error);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchManager();
  }, [fetchManager]);

  return (
    <div className="management">
      <div className="management-image">
        <img src={management} alt="" />
      </div>
      <AnimatedSection>
      <div className="management-image-title">
        <h2>Geleceği Birlikte İnşa Ediyoruz: Lojman Yönetim Ekibimizle Tanışın</h2>
      </div>
      </AnimatedSection>

      <div className="management-page-member">
        <AnimatedSection x={50} y={0.3} amount={0.2}>
          <div className="management-page-member-title">
            <h2>YÖNETİM KURULU</h2>
          </div>
        </AnimatedSection>
        <div className="managament-member-page-list">
          {data
            .filter((item) => item.boardType === 'management')
            .map((item) => (
              <React.Fragment key={item.id}>
                <AnimatedSection x={50} y={0} amount={0.4}>
                  <ManagementItem item={item} />
                </AnimatedSection>
                <div className="eoi"></div>
              </React.Fragment>
            ))}
        </div>

        <AnimatedSection x={-50} y={0.3} amount={0.2}>
          <div className="management-page-member-title">
            <h2>DENETİM KURULU</h2>
          </div>
        </AnimatedSection>
        <div className="managament-member-page-list">
          {data
            .filter((item) => item.boardType === 'audit')
            .map((item) => (
              <React.Fragment key={item.id}>
                <AnimatedSection x={-50} y={0} amount={0.4}>
                  <ManagementItem item={item} />
                </AnimatedSection>
                <div className="eoi"></div>
              </React.Fragment>
            ))}
        </div>
        <AnimatedSection x={-50} y={0.3} amount={0.2}>
          <div className="management-page-member-title">
            <h2>BİRİM SORUMLUSU</h2>
          </div>
        </AnimatedSection>
        <div className="managament-member-page-list">
          {data
            .filter((item) => item.boardType === 'unit')
            .map((item) => (
              <React.Fragment key={item.id}>
                <AnimatedSection x={-50} y={0} amount={0.4}>
                  <ManagementItem item={item} />
                </AnimatedSection>
                <div className="eoi"></div>
              </React.Fragment>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Management;
